export default "__VITE_ASSET__FSFktnPG__"